<template>
  <div class="talent-resume-list-item" v-if="resDomShow">
    <div class="talent-top-btn-pos-div">
      <div class="top-edit talent-top-btn-pos">
        <div class="ms-txt" v-if="from === 'option'">  
            <div class="btn-set" >
                <div> 
                <div v-if="resData.is_collect==1" @click="resumesLikes(0)">
                    <div style="color:#888D96">已收藏</div>
                </div>
                <div v-else @click="resumesLikes(1)">
                    <div style="color:#403CF0">收藏</div>
                </div>  
                </div>
            </div>     
            <div class="talent-top-btn" style="font-size:12px">
              <button v-if="resData.is_invite==0" class="invt" @click="openInviteDialog(1)">邀请投递</button>
              <button v-else class="invted">已邀请</button>
              <button v-if="resData.is_download==0" @click="openInviteDialog(2)">下载简历</button>
              <button v-else class="dowlan" @click="openInviteDialogUp">免费重下</button>
            </div>
        </div>
      </div>
      <div class="info-box">
        <div class="resume-info" @click="openResumeDetail">
          <el-col :span="11" class="user-box">
            <!-- add -->
            <TalentCenter-Item-User-Info :resData="resData"></TalentCenter-Item-User-Info>
          </el-col>
          <el-col :span="10" class="time-box talent-box">
            <TalentCenter-item-time-line :resData='resData'  :filterRef='filterRef'></TalentCenter-item-time-line>
          </el-col>
          <el-col :span="2" class="detail-box" style="margin-top: 32px;">
            详情
            <i class="el-icon-arrow-right"></i>
          </el-col>
        </div>      
      </div>
    </div>
  </div>
</template>

<script>
import TalentCenterItemTimeLine from '../widget/TalentCenterItemTimeLine'
import TalentCenterItemUserInfo from '../widget/TalentCenterItemUserInfo'
import axios from "@/utils/axios";



export default {
  props: ['from', 'resData', 'selectTab','invite_deliver_today_surplus','resume_download_num_surplus','filterRef'],
  data () {
    return {
      showTag: 1,      
    }
  },
  mounted () {
  },
  components: {
    TalentCenterItemTimeLine,
    TalentCenterItemUserInfo
  },
  watch: {
  },
  computed: {
    // 操作后不显示
    resDomShow () {
      if (this.from === 'option' ) {
        return true
      } else if (this.from === 'talent' ) {
        return true
      } else {
        return false
      }
    },
    dynamic(){
      let n=new Date();
      let last_visit_time=new Date(this.resData.last_visit_time);
      let res=n.getTime()-last_visit_time.getTime();
      return parseInt(res/(1000*60*60*24))
    },
  },
  methods: {
    resumesLikes (tag) {
      this.$axios.post('/recruitment/talent/collect', {
        status: tag,
        resume_user_id:this.resData.id
      }).then((res) => {
        // this.$message.success(tag==1?'收藏成功':'取消收藏成功');
        this.resData.is_collect = tag;
        // this.$emit('invite')
      })
    },
    openResumeDetail () {
      this.$emit('openDetail', this.resData.id)
    },
    openInviteDialog(status){
      let data={
        resData:this.resData,
        status:status
      }
      this.$emit('resDatad',data)
    },
    async openInviteDialogUp(){
        await axios.download("/recruitment/talent/download", {
          resume_key: this.resData.resume_key,
        });
    },
  }
}
</script>

<style lang='scss'>
@import '$styles/global.scss';

.talent-resume-list-item{
  width: 100%;
  background-color: #fff;
  margin-bottom: 10px;
  padding: 10px 0px 15px;
  border-radius: 4px;
  .talent-top-btn-pos-div{
    position: relative;
  }
  .talent-top-btn-pos{
    position: absolute;
  }
  .picker-style{
    width: 100%;
  }

  .top-edit{
    width: 100%;
    font-size: 14px;
    padding: 0 20px;
    @include flex-box(flex-end);

    .ms-txt{
      @include flex-box();

      span{
        color: $last-color;
      }

      span:nth-child(2) {
        margin-left: 20px;
      }
      .talent-top-btn{
        display: flex;
        button{
          padding: 0px 20px;
          height:32px;
          font-size: 14px;
          color: #fff;
          border-radius: 4px;
          background-color: #4061F8;
          cursor: pointer;
        }
        .invt{
          background-color: #2EC074;
          margin-right: 10px;
        }
        .invted{
          background: #fff;
          border:1px solid #2EC074;
          color: #2EC074;
          margin-right: 10px;
        }
        .dowlan{
          background: #fff;
          border:1px solid #4061F8;
          color: #4061F8;

        }
      }      
    }

    .color-change{
      color: $err-color !important;
    }
  }

  .info-box{
    width: 100%;
    background-color: #FFF;
    padding: 0 20px;

    .resume-info{
      width: 100%;
      cursor: pointer;
      @include flex-box(space-between);

      .user-box{
        width:450px !important;
        @include flex-box(flex-start);
        flex-wrap: nowrap;

        .re-avatar-img{
          width: 72px;
          height: 72px;
          border-radius: 50%;
          position: relative;
          top: -4px;
          border:1px solid #CFD7E1;
        }
      }

      .time-box{
        height: 100%;
      }
      .talent-box{
        margin-top: 28px;
      }
      .detail-box{
        color: #4061F8;
        font-size: 14px;
        text-align: right;
      }
    }
  }

  .re-option{
    margin-top: 20px;
    border-top: 1px solid $line-color;
    padding: 5px 20px;
    @include flex-box(space-between);
    width: 100%;

    .re-btn-style{
      width: 95px;
      height: 32px;
      padding: 0;
    }

    .change-ms-time{
      color: $guide-color;
      text-decoration: underline;
      cursor: pointer;
    }
    .option{
      @include flex-box();
      color: $sure-color;
      cursor: pointer;

      img{
        width: 16px;
        height: 16px;
        margin-top: 2px;
        margin-right: 6px;
      }
      div{
        display: flex;
      }
    }

    .option-no-res{
      color: $guide-color;
    }
    .mark-time{
      font-size: 12px;
      color: #3C4554;
      margin-right: 50px;
      display: flex;
    }
  }
  .btn-set{
    display: flex;
    div{
      div {
        line-height: 32px;
        margin-right: 10px;
        cursor: pointer;
      }
    }
    .Inappropriate{
      color: #92979D;
    }
  }
  // .inviteDialog{
  //   .el-dialog{
  //     box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
  //     border-radius: 8px;
  //     .el-dialog__body{
  //       padding:12px 15px 20px;
  //     }
  //   }
  //   .inviteDialog-top{
  //     display: flex;
  //     .inviteDialog-img{
  //       width: 72px;
  //       height: 72px;
  //       margin-top: 7px;
  //       margin-right: 20px;
  //       .el-image{
  //         border: 1px solid #CFD7E1;
  //         width: 100%;
  //         border-radius: 50%;
  //         height: 100%;
  //       }
  //     }
  //     .inviteDialog-right-top{
  //       display: flex;
  //       line-height: 30px;
  //       span{
  //         color: #3C4554;
  //         font-size: 18px;
  //         font-weight: bold;
  //       }
  //       button{
  //         padding: 6px 10px;
  //         border-radius: 4px;
  //         border: 1px solid #DAE2EF;
  //         background-color: #fff;
  //         color: #888D96;
  //         font-size: 12px;
  //         margin-left: 15px;
  //       }
  //     }
  //     .inviteDialog-right-center{
  //       margin: 10px 0;
  //       color: #888D96;
  //       font-size: 14px;
  //       line-height: 14px;
  //       span{
  //         margin: 0 10px;
  //       }
  //     }
  //     .inviteDialog-right-bottom{
  //       color: #3C4554;
  //       font-size: 14px;
  //     }
  //   }
  //   .inviteDialog-content{
  //     margin-top: 35px;
  //     color: #303B4B;
  //     font-size: 16px;
  //     font-weight: bold;
  //     .inviteDialog-content-dow{
  //       font-size: 12px;
  //       font-weight: 400;
  //       color: #303B4B;
  //       line-height: 24px;
  //     }
  //     .el-select{
  //       margin-top: 10px;
  //     }
  //   }
  //   .inviteDialog-footer{
  //     margin-top: 41px;
  //     display: flex;
  //     justify-content: space-between;
  //     .dialogZD-bottom-left{
  //       max-width: 225px;
  //       overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
  //       padding: 0 3px 0 10px;
  //       border-radius: 4px;
  //       height: 30px;
  //       line-height: 30px;
  //       background-color: #FFEFE9;
  //       color: #F4771D;
  //       font-size: 12px;
  //       border-top-right-radius: 0;
  //       border-bottom-right-radius: 0;
  //       span{
  //         color: #303B4B;
  //       }
  //     }
  //     .dialogZD-bottom-left-triangle{
  //       width: 0;
  //       height: 0;
  //       border-top: 15px solid transparent;
  //       border-bottom: 15px solid transparent;
  //       border-left: 16px solid #FFEFE9;
  //     }
  //     .dialogZD-bottom-button{
  //       button{
  //         padding: 8px 21px;
  //         border-radius: 4px;
  //         font-size: 14px;
  //         color: #fff;
  //         cursor: pointer;
  //       }
  //       .dialogZD-bottom-buttonL{
  //         background-color: #F4771D;
  //         margin-right: 10px;
  //       }
  //       .dialogZD-bottom-buttonR{
  //         background-color: #4061F8;
  //       }
  //     }    
  //   }
  // }
}
</style>
